import { defineNuxtPlugin } from "nuxt/app"

export default defineNuxtPlugin({
  name: "intercom",
  parallel: true,
  setup() {
    const { user } = useUser()
    const { updateIntercomWithUser } = useIntercom()

    updateIntercomWithUser(user.value)
  },
})
